var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPomodoro = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 25,
  viewBox: "0 0 19 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M14 13.5v1.8a.5.5 0 1 1-1 0v-1.8a.5.5 0 1 1 1 0ZM5.5 13a.5.5 0 0 0-.5.5v1.8a.5.5 0 1 0 1 0v-1.8a.5.5 0 0 0-.5-.5Zm4-1a.5.5 0 0 0-.5.5v2.8a.5.5 0 1 0 1 0v-2.8a.5.5 0 0 0-.5-.5Zm9.5 2.5C19 21.404 14.747 25 9.5 25S0 21.404 0 14.5 4.253 0 9.5 0 19 7.596 19 14.5ZM11 22l-1.5-3L8 22h3Zm6.76-5c.16-.824.24-1.66.24-2.5C18 8.385 14.208 1 9.5 1S1 8.385 1 14.5c0 .84.08 1.676.24 2.5h16.52Z"
})));
export default SvgPomodoro;